import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { BankerProvider } from "presentation/store/Banker/BankerProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { BankerMaintenance } from "presentation/view/section/Banker/BankerMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const BankerContMain = () => {
    return <ANAInfoWrapper permission={Permission.BANKER_MAINTENANCE}>
        <MessageBarWrapper>
            <BankerProvider>
                <GridStyles />
                <BankerMaintenance />
            </BankerProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default BankerContMain;